/** Indica se a conta a pagar ainda permite efetuar pagamento. */
export function canPayAccountsPayable(status?: string | null): boolean {
  if (!status) return false;
  const normalized = status.trim().toLowerCase();
  if (normalized.includes('pago') && !normalized.includes('parcialmente')) return false;
  if (normalized === 'paid') return false;
  if (normalized === 'cancelado' || normalized === 'cancelled') return false;
  return (
    normalized === 'pendente' ||
    normalized === 'aprovado' ||
    normalized === 'parcialmente pago' ||
    normalized.startsWith('parcialmente')
  );
}
